<template>
  <v-app id="ecco-admin" :class="{ 'authenticated': showSideMenu || showFrontDeskSideMenu }">
    <top-bar v-if="!isTeacherClassRoute"/>

    <side-menu v-if="showSideMenu" />
    <side-menu-front-desk v-if="showFrontDeskSideMenu" />

    <v-main id="main" class="main-bg">
      <v-container fluid>
        <v-row class="justify-center">
          <v-col cols="12">
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import TopBar from '@/components/topBar'
import SideMenu from '@/components/sideMenu'
import SideMenuFrontDesk from '@/components/sideMenuFrontDesk'

export default {
  components: {
    TopBar,
    SideMenu,
    SideMenuFrontDesk,
  },
  computed: {
    isAuthenticated() {
      return this.$store.state.auth.accessToken
    },
    userRole() {
      return this.$store.state.auth.payload.user.role
    },
    isTeacherClassRoute() {
      return this.$route.name === 'TeacherClassConfirmRoute'
    },
    isCRMUser() {
      return (this.$store.state.auth.payload.user.firstName === 'RaEmployee')
    },
    isDypCzar() {
      return (this.$store.state.auth.payload.user.firstName === 'DypCzar')
    },
    isFrontDesk() {
      return (this.$store.state.auth.payload.user.firstName === 'FrontDesk')
    },
    showSideMenu() {
      if (this.isAuthenticated) {
        if (this.isCRMUser) return false;
        if (this.isDypCzar) return false;
        if (this.isFrontDesk) return false;
        return true;
      } else {
        if (this.isTeacherClassRoute) return false;
        return false;
      }
    },
    showFrontDeskSideMenu() {
      if (this.isAuthenticated &&
          this.userRole === 'front-desk' ||
          this.userRole === 'studio-manager') return true;
      return false;
    },
    showTopBar() {
      if (this.isAuthenticated && !this.isCRMUser) return true;
      if (this.isAuthenticated && this.isCRMUser) return false;
      return true;
    },
    darkMode() {
      return this.$store.state.meta.darkMode
    }
  },
}
</script>

<style lang="scss">
@import url("https://use.typekit.net/gux3riu.css");
@import "~vue-wysiwyg/dist/vueWysiwyg.css";

.text--center {
  text-align: center;
}

.authenticated #main {
  margin-left: 240px;
  width: calc(100vw - 240px);
}
</style>